import { tracked } from '@glimmer/tracking';

import FilterSortReport from 'webapp/models-custom/filter-sort/report';

export default class FilterSortReportInGrid extends FilterSortReport {
	@tracked override viewId = 'grid';

	override itemDomSelector = 'li.filter-sort-item';
}
